import React, { useState, useEffect } from 'react';
import { hasAdminPermission } from 'authHelper'
import { useMsal } from '@azure/msal-react';
const AuthContext = React.createContext({
  isAdmin: false
});

export const AuthContextProvider = (props) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const { instance, accounts } = useMsal()
 

  async function getAdminPermission() {
    try {
      setIsAdmin(await hasAdminPermission(instance, accounts))
    }
    catch {
      setIsAdmin(false)
    }
  }

  useEffect(() => {
    getAdminPermission()
  }, []);


  return (
    <AuthContext.Provider
      value={{
        isAdmin: isAdmin
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;